import { render } from "./aLable.vue?vue&type=template&id=3beb18a8"
import script from "./aLable.vue?vue&type=script&lang=js"
export * from "./aLable.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__